import { InternalError, type InternalErrorPayload } from '@/core/shared/errors/internal.error';

/**
 * Manual outreach was rejected with a 409 because the AI recruiter already has an
 * conversation thread open for this candidate (queued outreach, screening, scheduling).
 * Nothing is wrong and nothing was lost, so this is not a failure to report.
 */
export class ActiveThreadExistsError extends InternalError {
  constructor(payload: InternalErrorPayload = {}) {
    super('The AI recruiter already has an active thread with this candidate', payload);
  }
}
